import { render } from "./form-mail.vue?vue&type=template&id=3d7c4680&scoped=true"
import script from "./form-mail.vue?vue&type=script&lang=js"
export * from "./form-mail.vue?vue&type=script&lang=js"

import "./form-mail.vue?vue&type=style&index=0&id=3d7c4680&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7c4680"]])

export default __exports__